import { ReactNode } from 'react'
import { css, Theme } from '@emotion/react'

// セクションコンテナ
const sectionContainerStyle = (isFirst: boolean, showDivider: boolean) => css`
  ${!isFirst && `margin-top: 16px;`}
  ${showDivider &&
  `
    border-top: 1px solid #e0e0e0;
    margin-top: 16px;
    padding-top: 16px;
  `}
`

// セクションタイトル
const sectionTitleStyle = (t: Theme) => css`
  font-size: 1.8rem;
  font-weight: 400;
  line-height: 1.8rem;
  color: #454545;
  margin-bottom: 16px;
`

// フィールドグループ
const fieldGroupStyle = css`
  display: flex;
  flex-direction: column;
`

type Props = {
  title?: string
  isFirst?: boolean
  showDivider?: boolean
  children: ReactNode
}

export const FormSection = ({
  title,
  isFirst = false,
  showDivider = false,
  children,
}: Props) => {
  return (
    <div css={sectionContainerStyle(isFirst, showDivider)}>
      {title && <h3 css={sectionTitleStyle}>{title}</h3>}
      <div css={fieldGroupStyle}>{children}</div>
    </div>
  )
}
